import { TwitchConfigContext } from "@/context/twitchConfigContext.js";
import { useTwitchConfigState } from "@/hooks/useTwitchConfig.js";

export function TwitchConfigProvider({ children }: { children: React.ReactNode }) {
  const value = useTwitchConfigState();
  return <TwitchConfigContext.Provider value={value}>{children}</TwitchConfigContext.Provider>;
}
